import React, { useState } from 'react';
import { SingleFileState } from 'screens/EpisodeOptionsScreen/components/EpisodeContent/SingleFileState';
import { useQuickUploadFile } from 'contexts/QuickUploadFile';
import { EpisodeContentLabel, UploaderStateContainer } from './styles';
import { IdleState } from './IdleState';
import { EpisodeContentState } from './states';

type EpisodeContentProps = {
  file: File | null;
};

export const EpisodeContent = ({ file: uploadedFile }: EpisodeContentProps) => {
  const [media, setMedia] = useState(uploadedFile);

  const { setQuickUploadFile } = useQuickUploadFile();

  const containsMedia = !!media;
  const episodeContentState = containsMedia
    ? EpisodeContentState.SINGLE_FILE
    : EpisodeContentState.IDLE;

  const onUploadFile = (file: File) => {
    setQuickUploadFile(file);
    setMedia(file);
  };

  const renderContent = () => {
    switch (episodeContentState) {
      case EpisodeContentState.SINGLE_FILE:
        return <SingleFileState file={media} />;
      case EpisodeContentState.IDLE:
      default:
        return <IdleState onUploadFile={onUploadFile} />;
    }
  };

  return (
    <div>
      <EpisodeContentLabel>Episode content</EpisodeContentLabel>
      <UploaderStateContainer containsMedia={containsMedia}>
        {renderContent()}
      </UploaderStateContainer>
    </div>
  );
};
